// removed by extract-text-webpack-plugin
module.exports = {"flying-letter-container":"FlyingLetter__flying-letter-container","flyingLetterContainer":"FlyingLetter__flying-letter-container"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loader/components/FlyingLetter/FlyingLetter.mobile.css
// module id = 1168
// module chunks = 8